import { User } from '../../../../../generated/graphql.generated';

const SEVEN_TO_EIGHT = `Y07:00-20:00`;

/**
 * D.14 — new movers default to "Available for Assignment" with every
 * capability enabled, so office staff don't have to click each one on.
 */
export const defaultAvailability = [
	SEVEN_TO_EIGHT,
	SEVEN_TO_EIGHT,
	SEVEN_TO_EIGHT,
	SEVEN_TO_EIGHT,
	SEVEN_TO_EIGHT,
	SEVEN_TO_EIGHT,
	SEVEN_TO_EIGHT,
];

export const defaultCrewSettings: Partial<User> = {
	available: true,
	availability: defaultAvailability,
	maxHoursPerDay: 24,
	maxHoursPerWeek: 40,
	payPeriodStart: 1,
	overtimeRate: 1.5,
	rateHourly: 0,
	timezone: undefined,
	capabilities: ['CrewLead', 'Crew', 'Driver', 'Packer', 'Operations'],
};
